import { useTransition } from "react";
import { deleteEntityById } from "@/lib/api/deleteEntity";

import { Button } from "@/components/common/button";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogClose,
} from "@/components/common/dialog";

const DeleteEntityDialog = ({ id, entityType, redirectTo }) => {
  const [isPending, startTransition] = useTransition();

  const onSubmit = () => {
    startTransition(async () => {
      try {
        await deleteEntityById({ entityType, id, redirectTo });
      } catch (error) {
        console.error("DeleteEntityDialog: Error deleting entity:", error);
      }
    });
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          faIcon={{ style: "far", name: "trash-can" }}
          variant="dangerText"
          size="iconSmall"
          disabled={isPending}
        />
      </DialogTrigger>

      <DialogContent>
        <DialogHeader>
          <DialogTitle>Weet je het zeker?</DialogTitle>
          <DialogDescription>
            Je staat op het punt om dit item te verwijderen. Deze actie kan niet
            ongedaan worden gemaakt.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className={"sm:justify-end"}>
          <DialogClose asChild>
            <Button type="button" variant="grey" disabled={isPending}>
              Annuleren
            </Button>
          </DialogClose>

          <Button
            type="button"
            onClick={onSubmit}
            variant="danger"
            disabled={isPending}
            loading={isPending}
          >
            Permanent verwijderen
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export { DeleteEntityDialog };
